import { createSlice } from '@reduxjs/toolkit';

const initialState = {

  notification: {
    isOpen:   false,
    message:  '',
    severity: 'error',
  }
}

export const appSlice = createSlice({
    name: 'App',
    initialState,
    reducers: {
      showNotification: (state, action) => {
        state.notification = {
          isOpen: true,
          message: action.payload.message,
          severity: action.payload.severity || 'error',
        };
      },
      clearNotification: (state) => {
        state.notification = initialState.notification;
      }
    },
});

export const { showNotification, clearNotification } = appSlice.actions;

export default appSlice.reducer;